import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const testimonials = [{
  quote: 'Después de 3 años de terapia, este protocolo hizo en semanas lo que no lograron los psicólogos. Localicé el trauma en mi cuerpo y sentí cómo se disolvía.',
  name: 'Marcela V.',
  age: 42,
  location: 'Colombia',
  initials: 'MV'
}, {
  quote: 'Siempre creí que la física cuántica era teoría vacía. Cuando apliqué la Técnica de la Doble Rendija a mi divorcio, algo se rompió en mí — de la mejor manera.',
  name: 'Roberto A.',
  age: 51,
  location: 'México',
  initials: 'RA'
}, {
  quote: 'La sección del Punto Cero cambió mi forma de levantarme cada mañana. Ya no cargo con el peso del pasado desde el primer segundo del día.',
  name: 'Ana S.',
  age: 38,
  location: 'Argentina',
  initials: 'AS'
}, {
  quote: "Compré por curiosidad y terminé llorando de alivio. Por fin alguien que no me dice 'piensa positivo' sino que explica POR QUÉ no funcionaba antes.",
  name: 'Carlos M.',
  age: 47,
  location: 'España',
  initials: 'CM'
}, {
  quote: 'El módulo del Entrelazamiento me explicó por qué seguía repitiendo los mismos patrones de pareja. Nadie me lo había explicado así. Nunca.',
  name: 'Diana R.',
  age: 35,
  location: 'Venezuela',
  initials: 'DR'
}, {
  quote: 'Apliqué el Protocolo Estado Cero durante 7 días y mi ansiedad bajó notablemente. Es práctico, profundo y diferente a todo lo que había leído.',
  name: 'Luis H.',
  age: 44,
  location: 'Chile',
  initials: 'LH'
}, {
  quote: 'No soy espiritual, soy ingeniero. Pero el marco científico-cuántico me permitió entrar al proceso sin resistencia. Funcionó.',
  name: 'Andrés P.',
  age: 53,
  location: 'Colombia',
  initials: 'AP'
}];
// Duplicate for seamless infinite scroll
const carouselItems = [...testimonials, ...testimonials];
export function TestimonialCarousel() {
  const revealRef = useScrollReveal();
  return <section className="bg-brand-violetDark py-10 overflow-hidden" data-id="element-188">
      <div ref={revealRef} className="reveal" data-id="element-189">
        <div className="text-center mb-12 px-5" data-id="element-190">
          <div className="text-brand-gold text-[11px] tracking-[0.15em] uppercase mb-4" data-id="element-191">
            TESTIMONIOS
          </div>
          <h2 className="font-display italic text-[42px] text-brand-cream leading-tight max-w-2xl mx-auto" data-id="element-192">
            Lo que dicen quienes ya
            <br data-id="element-193" />
            han elegido RENACER
          </h2>
        </div>

        <div className="w-full relative" data-id="element-194">
          {/* Gradient masks for smooth edges */}
          <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-brand-violetDark to-transparent z-10 pointer-events-none" data-id="element-195" />
          <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-brand-violetDark to-transparent z-10 pointer-events-none" data-id="element-196" />

          <div className="flex gap-5 w-fit animate-scroll-left hover:[animation-play-state:paused] px-5" data-id="element-197">
            {carouselItems.map((item, i) => <div key={i} className="w-[280px] shrink-0 bg-brand-cardBg border border-brand-cardBorder rounded-[16px] p-[28px_24px] transition-all duration-300 hover:bg-white/[0.07] hover:border-brand-gold/40" data-id="element-198">
                <div className="text-brand-gold text-[14px] tracking-[3px] mb-4" data-id="element-199">
                  ★★★★★
                </div>
                <p className="font-display italic font-light text-[17px] text-brand-cream/85 leading-[1.7] mb-5" data-id="element-200">
                  "{item.quote}"
                </p>
                <div className="flex items-center gap-[10px]" data-id="element-201">
                  <div className="w-[36px] h-[36px] rounded-full bg-brand-violet flex items-center justify-center font-body text-[13px] font-medium text-white" data-id="element-202">
                    {item.initials}
                  </div>
                  <div data-id="element-203">
                    <div className="font-body text-[14px] font-medium text-brand-cream/80" data-id="element-204">
                      {item.name}
                    </div>
                    <div className="font-body text-[12px] text-brand-cream/40" data-id="element-205">
                      {item.age} &middot; {item.location}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}